import React from 'react'
import LegalLayout, { Section, Para, Bullets, Accent } from '../components/LegalLayout'

const TermsAndConditions = () => {
  return (
    <LegalLayout title='Terms & Conditions' lastUpdated='25 June 2026'>
        <Para>
          These Terms &amp; Conditions (“Terms”) govern your use of this website and any services or
          products offered by <Accent>Nilay Singh</Accent> (“we”, “us”, or “our”). By accessing this
          website or making a payment, you agree to be bound by these Terms. If you do not agree,
          please do not use this website or our services.
        </Para>

        <Section heading='1. Services'>
          <Para>
            We provide software development and related digital services and products. The specific
            scope, deliverables, timelines, and fees for any engagement will be agreed upon between you
            and us in writing (for example, by email or a quotation) before work begins.
          </Para>
        </Section>

        <Section heading='2. Pricing & Payments'>
          <Bullets items={[
            'All prices are quoted in Indian Rupees (INR) unless stated otherwise.',
            'Payments are processed securely through the Razorpay payment gateway.',
            'You agree to provide current, complete, and accurate billing information.',
            'We reserve the right to change our prices at any time; any change will not affect orders already confirmed.'
          ]} />
        </Section>

        <Section heading='3. Use of the Website'>
          <Para>You agree that you will not:</Para>
          <Bullets items={[
            'Use the website for any unlawful or fraudulent purpose.',
            'Attempt to gain unauthorised access to the website, its servers, or related systems.',
            'Interfere with or disrupt the website or the services provided through it.',
            'Reproduce, duplicate, or resell any part of the website or services without our permission.'
          ]} />
        </Section>

        <Section heading='4. Intellectual Property'>
          <Para>
            Unless otherwise agreed in writing, all content on this website — including text, designs,
            graphics, logos, and code — is owned by or licensed to us and is protected by applicable
            intellectual property laws. Ownership of deliverables produced under a paid engagement
            transfers to the client only upon full and final payment.
          </Para>
        </Section>

        <Section heading='5. Refunds & Cancellations'>
          <Para>
            Payments are subject to our <Accent>Refund Policy</Accent>. Please review it carefully
            before making a payment.
          </Para>
        </Section>

        <Section heading='6. Limitation of Liability'>
          <Para>
            To the maximum extent permitted by law, we shall not be liable for any indirect,
            incidental, or consequential damages arising out of your use of this website or our
            services. Our total liability for any claim shall not exceed the amount actually paid by
            you for the relevant service.
          </Para>
        </Section>

        <Section heading='7. Third-Party Links'>
          <Para>
            This website may contain links to third-party websites. We are not responsible for the
            content, privacy practices, or policies of any third-party websites.
          </Para>
        </Section>

        <Section heading='8. Governing Law'>
          <Para>
            These Terms are governed by and construed in accordance with the laws of India. Any
            disputes shall be subject to the exclusive jurisdiction of the courts of Ghaziabad, Uttar
            Pradesh.
          </Para>
        </Section>

        <Section heading='9. Changes to These Terms'>
          <Para>
            We may revise these Terms at any time. The latest version will always be available on this
            page with an updated “Last updated” date. Continued use of the website constitutes
            acceptance of the revised Terms.
          </Para>
        </Section>

        <Section heading='10. Contact Us'>
          <Para>For any questions regarding these Terms, please contact us at:</Para>
          <Bullets items={[
            <><Accent>Name:</Accent> Nilay Singh</>,
            <><Accent>Email:</Accent> snilay011@gmail.com</>,
            <><Accent>Phone:</Accent> +91 9810237655</>,
            <><Accent>Address:</Accent> Shipra Riviera, Indirapuram, Ghaziabad, Uttar Pradesh, India</>
          ]} />
        </Section>
    </LegalLayout>
  )
}

export default TermsAndConditions
